// extracted by mini-css-extract-plugin
module.exports = {"footerTop":"PlasmicFooterTop_footerTop__wMOt3","footerTopNav":"PlasmicFooterTop_footerTopNav__2THVf","footerTopDownload":"PlasmicFooterTop_footerTopDownload__13UWV"};